// Vendor
import $ from 'jquery';
import Helper from '../helpers/util';

class TagFilters {
	constructor(el) {
		this.$el = $(el);
		this.$filterToggles = this.$el.find('[data-tag]');
		this.$filterTiles = $('[data-filter-tag]');
		this.activeFilters = new Set();

		this.filter();

		this.attachEvents();

		this.$el.data('init', true);
	}

	filter() {
		this.$filterTiles.each((idx, el) => {
			let match = false;
			if (this.activeFilters.size === 0) {
				match = true;
			}
			$.each(
				$(el)
					.data('filter-tag')
					.split(','),
				(idxTag, tag) => {
					if (this.activeFilters.has(tag)) {
						match = true;
					}
				}
			);

			$(el).toggle(match);
		});
	}

	attachEvents() {
		this.$filterToggles.on('click', event => {
			const $toggle = $(event.currentTarget);
			const tag = $toggle.data('tag');
			if ($toggle.hasClass('active')) {
				this.activeFilters.delete(tag);
				$toggle.removeClass('active');
			} else {
				this.activeFilters.add(tag);
				$toggle.addClass('active');
			}
			this.filter();
		});
	}
}

const _init = () => {
	// Elements
	let $el = $('.elp-tag-filters');
	if ($el.length) {
		$el.each((e, v) => {
			if (!$(v).data('init')) {
				new TagFilters($(v));
			}
		});
	}
};

_init();
Helper.pubsub.subscribe('initComponents', function() {
	_init();
});
